/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */

export default function focusFix() {
  let target = null;
  let onFocus = false;
  let disableBlur = true;

  function run(e) {
    if (e.target && e.target.dataset && e.target.dataset.preventFromBlur) {
      window.visualViewport.removeEventListener('scroll', run);
      return;
    }

    setTimeout(() => {
      target.blur();
      target = null;
    }, 200);

    window.visualViewport.removeEventListener('scroll', run);
  }

  document.addEventListener('focusout', () => {
    onFocus = false;
    disableBlur = true;
  });

  document.addEventListener('focusin', (e) => {
    onFocus = true;

    if (e.target && e.target.dataset && e.target.dataset.preventFromBlur) {
      disableBlur = true;
    }

    setTimeout(() => {
      disableBlur = false;
    }, 500);

    target = e.target;
    window.visualViewport.removeEventListener('scroll', run);

    setTimeout(() => {
      window.visualViewport.addEventListener('scroll', run);
    }, 500);
  });

  function onViewportChange() {
    if (disableBlur === false) {
      target && target.blur();
      disableBlur = true;
    }
  }

  window.visualViewport.addEventListener('scroll', onViewportChange);
  window.visualViewport.addEventListener('orientationchange', onViewportChange);
}
